import { useLayoutEffect, useState } from "react";
import moment from "moment-jalaali";
import Urls from "../../../Utility/Urls";
import AvatarDefault from "../../../Assets/images/AvatarDefault.jpg";
import DashboardReq from "../../../Utility/Requester/DashboardReq";
import DateTime from "../../../Utility/Method/DateTime";
import BookingReq from "../../../Utility/Requester/BookingReq";
import { TodayObj } from "../../../Utility/TodayObj";
import { Notify } from "../../../UIcomponent/NotificationManager";
import LocalAppConfig from "../../../Utility/Method/LocalAppConfig";

const appConfig = LocalAppConfig.Get();

const useHook = ({ data, role }) => {
  let allowedToJoin = false;

  const [didMount, setDidMount] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [invoiceAction, setInvoiceAction] = useState({
    id: null,
    active: false,
  });
  const [scheduleState, setScheduleState] = useState({
    TeacherUserID: null,
    SessionID: null,
    disable: true,
    slot: null,
    Data: [],
    isSubmitting: false,
    selectedSlot: null,
  });

  useLayoutEffect(() => {
    moment.locale("en");
    setDidMount(true);
  }, []);

  const WeekDateTimeObj = (firstDay, mode) => {
    if (mode == "next") {
      return {
        dateTimeFrom: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
        ).toISOString(),
        dateTimeTo: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day + 7, 0, 0, 0)
        ).toISOString(),
      };
    } else if (mode == "previous") {
      return {
        dateTimeFrom: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
        ).toISOString(),
        dateTimeTo: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day + 7, 0, 0, 0)
        ).toISOString(),
      };
    } else {
      return null;
    }
  };

  const GetAvailabilty = (firstDay, mode, SessionID, TeacherUserID, slot) => {
    let params = {
      timeZone: DateTime.timeZone(),
      dateTimeFrom: WeekDateTimeObj(firstDay, mode).dateTimeFrom,
      dateTimeTo: WeekDateTimeObj(firstDay, mode).dateTimeTo,
    };
    BookingReq.getAvailability(TeacherUserID, params)
      .then((res) => {
        let newResult = [];
        newResult = res.data.map((each) => {
          return {
            status: 1,
            date_time_from: each.from,
            date_time_to: each.to,
          };
        });
        if (typeof SessionID === "undefined") {
          SessionID = scheduleState.SessionID;
        }
        if (slot === null) {
          slot = scheduleState.slot;
        }

        setScheduleState({
          ...scheduleState,
          TeacherUserID,
          SessionID,
          slot,
          Data: [...newResult],
          loading: false,
        });
      })
      .catch((err) => {});
  };

  const ScheduleAction = (SessionID, TeacherUserID, length) => {
    let slot = length / 30;
    setScheduleModal(true);
    setScheduleState({
      ...scheduleState,
      SessionID,
      TeacherUserID,
      slot,
      loading: true,
    });
    GetAvailabilty(TodayObj(0), "next", SessionID, TeacherUserID, slot);
  };

  const onSelect = (data) => {
    let newdata = data.filter((each) => each.status === 3)[0];
    setScheduleState({
      ...scheduleState,
      slot: scheduleState.slot,
      data,
      disable: false,
      selectedSlot: newdata,
    });
  };
  const onDeselect = (leftChoise, data) => {
    setScheduleState({
      ...scheduleState,
      disable: true,
      selectedSlot: [],
    });
  };
  const onNextWeek = (firstDay) => {
    setScheduleState({
      ...scheduleState,
      loading: true,
    });
    GetAvailabilty(
      firstDay,
      "next",
      scheduleState.id,
      scheduleState.TeacherUserID,
      scheduleState.slot
    );
  };
  const onPreviousWeek = (firstDay) => {
    setScheduleState({
      ...scheduleState,
      loading: true,
    });
    GetAvailabilty(
      firstDay,
      "previous",
      scheduleState.id,
      scheduleState.TeacherUserID,
      scheduleState.slot
    );
  };
  const submitSchedule = () => {
    let ID = scheduleState.SessionID;
    let data = {
      TimeSlot: {
        From: scheduleState.selectedSlot.date_time_from,
        To: scheduleState.selectedSlot.date_time_to,
      },
    };
    setScheduleState({
      ...scheduleState,
      disable: true,
      isSubmitting: true,
    });
    DashboardReq.Schedule(ID, data)
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => {
        Notify("error", err.response.message, 4000);
        setScheduleState({
          ...scheduleState,
          disable: false,
          isSubmitting: false,
        });
      });
  };

  const AvatarSwitcher = (avatar, UserAvatar) => {
    if (!UserAvatar) {
      return AvatarDefault;
    }

    switch (avatar) {
      case "":
        return AvatarDefault;
      default:
        return Urls.avatar() + UserAvatar;
    }
  };

  if (data.Session) {
    let now = new Date();
    let floor = new Date(data.Session.from);
    let ceil = new Date(data.Session.to);
    if (role === "Student") {
      floor.setMinutes(
        floor.getMinutes() - appConfig.StudentBeforeClassJoinIntervalInMinutes
      );
      ceil.setMinutes(
        ceil.getMinutes() + appConfig.StudentAfterClassJoinIntervalInMinutes
      );
    } else {
      floor.setMinutes(
        floor.getMinutes() - appConfig.TeacherBeforeClassJoinIntervalInMinutes
      );
      ceil.setMinutes(
        ceil.getMinutes() + appConfig.TeacherAfterClassJoinIntervalInMinutes
      );
    }

    allowedToJoin = now < ceil && now > floor;
  }

  return {
    states: {
      didMount,
      scheduleModal,
      invoiceAction,
      scheduleState,
      allowedToJoin,
    },
    setters: {
      setDidMount,
      setScheduleModal,
      setInvoiceAction,
      setScheduleState,
    },
    methods: {
      setScheduleModal,
      WeekDateTimeObj,
      GetAvailabilty,
      ScheduleAction,
      onSelect,
      onDeselect,
      onNextWeek,
      onPreviousWeek,
      submitSchedule,
      AvatarSwitcher,
    },
  };
};

export default useHook;
